
  import ipxRuntime$y0UqyO9FWF9GmxiY5koK0l2mgpwzRh5obUy_45s_45GMPGk from '/vercel/path0/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.9.3_magicast@0.5.2/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 576,
    "md": 768,
    "lg": 992,
    "xl": 1280,
    "2xl": 3072,
    "xs": 320,
    "smx": 428,
    "xxl": 1366,
    "2lg": 2048
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "cp.trueislam.co.uk",
    "trueislam.local",
    "localhost"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$y0UqyO9FWF9GmxiY5koK0l2mgpwzRh5obUy_45s_45GMPGk, defaults: {} }
    }
  }
